import { IWorkingTime } from "@hero/shared/models/workingTime";
import { IWorkingTimeUploadDay } from "@hero/shared/models/workingTimeUploadDay";
import { IWorkingTimeUploadAction, WorkingTimeUploadTypes } from "../actions/workingTimeUpload.action";

export interface IWorkingTimeUploadState {
    uploadDays: IWorkingTimeUploadDay[];
    holidays: string[];
    complementDays: string[];
    records: IWorkingTime[];
    loading: boolean;
    error: any;
}

const initState: IWorkingTimeUploadState = {
    uploadDays: [],
    holidays: [],
    complementDays: [],
    records: [],
    loading: false,
    error: null,
};

const workingTimeUpload = (state = initState, action: IWorkingTimeUploadAction): IWorkingTimeUploadState => {
    switch (action.type) {
        case WorkingTimeUploadTypes.GET_WORKING_TIME_UPLOAD:
            return { ...state, loading: true, error: null };
        case WorkingTimeUploadTypes.GET_WORKING_TIME_UPLOAD_SUCCESS:
            return {
                ...state,
                uploadDays: action.status?.uploadDays ?? [],
                holidays: action.status?.holidays ?? [],
                complementDays: action.status?.complementDays ?? [],
                records: action.records ?? [],
                loading: false,
            };
        case WorkingTimeUploadTypes.GET_WORKING_TIME_UPLOAD_FAILED:
            return {
                ...state,
                loading: false,
                error: action.error,
                uploadDays: [],
                holidays: [],
                complementDays: [],
                records: [],
            };
        default:
            return state;
    }
};

export default workingTimeUpload;
